<template>
    <div class="image-component">
        <div>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi architecto atque consequuntur dignissimos doloremque dolores doloribus ducimus eius expedita laudantium modi molestias, neque officia optio perspiciatis reiciendis saepe sint voluptatum?
        </div>
    </div>
</template>

<script>
	// add imports here

	//ADD JSDOC HERE!!!!!
	export default {
		props: ['content'],
		mounted() {
			this.content;
		},
		data() {
			return {}
		},
		methods: {}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/image/ImageDataComponent.vue?677c0dba